import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { ThirdStepForm } from 'shared/components/ThirdStepForm';
import { useAppDispatch } from 'shared/hooks';
import { selectFormLeadId, selectFormStatus } from 'shared/selectors/form';
import { setModalStatus } from 'shared/slices';
import { sendAdditionalForm } from 'shared/thunks';
import { EStatus } from 'shared/types/form';
import { EModalStatus } from 'shared/types/modal';

export const ThirdStepFormContainer: React.FC = () => {
  const leadId = useSelector(selectFormLeadId);

  const formStatus = useSelector(selectFormStatus);

  const [roomsCount, setRoomsCount] = useState<string[]>([]);

  const [repair, setRepair] = useState<string[]>([]);

  const [furniture, setFurniture] = useState<string[]>([]);

  const dispatch = useAppDispatch();

  const handleRoomsCount = useCallback((value: string[]) => {
    setRoomsCount(value);
  }, []);

  const handleRepair = useCallback((value: string[]) => {
    setRepair(value);
  }, []);

  const handleFurniture = useCallback((value: string[]) => {
    setFurniture(value);
  }, []);

  const handleNextBtn = useCallback(async () => {
    if ((roomsCount.length > 0 || repair.length > 0 || furniture.length > 0) && leadId) {
      await dispatch(
        sendAdditionalForm({ roomsCount: roomsCount[0], repair: repair[0], furniture: furniture[0], leadId }),
      );
    } else {
      dispatch(setModalStatus({ status: EModalStatus.Success }));
    }
  }, [dispatch, furniture, leadId, repair, roomsCount]);

  return (
    <ThirdStepForm
      isLoading={formStatus === EStatus.Loading}
      roomsCount={roomsCount}
      onRoomsCount={handleRoomsCount}
      repair={repair}
      onRepair={handleRepair}
      furniture={furniture}
      onFurniture={handleFurniture}
      onNextBtn={handleNextBtn}
    />
  );
};
